import clsx from 'clsx';
import { FC } from 'react';

import css from './style.module.scss';

interface Props {
	className?: string;
}

const AnimatedWavyBackground: FC<Props> = ({ className }) => (
	<>
		<div className={clsx(css.wave, css.wave1, className)} />
		<div className={clsx(css.wave, css.wave2, className)} />
		<div className={clsx(css.wave, css.wave3, className)} />
	</>
);

export default AnimatedWavyBackground;
